import { API, graphqlOperation } from "aws-amplify";
import { print as gqlToString } from 'graphql/language';
import { stringsToNulls } from './dynamodb.js';
import { logError } from './logger.js';
import {
  lensPath,
  set,
  replace,
  clone,
  mapObjIndexed,
  pipe,
  complement,
  isEmpty,
  isNil,
  filter,
  map,
  mergeAll,
  range,
  concat,
  toString
} from 'ramda';


export const adminQuery = async (queryAsAST, variables) => {
  const query = gqlToString(queryAsAST);

  try {
    const response = await window.adminClient.query({
      query: queryAsAST,
      variables: variables, 
      fetchPolicy: 'no-cache'
    });
    return response.data;
  } catch(err) {
    logError({ error: err, query: query, variables: variables });
    return err;
  }
};

export const adminMutation = (data, fixDataArr, gql, onSuccessFn) => {
  window.adminClient.mutate({
    mutation: gql,
    variables: { input: prepareForSave(data, fixDataArr) }
  })
    .then(({data}) => { onSuccessFn(data); })
    .catch(logError);
};


// https://github.com/apollographql/graphql-tag
export const gqlOperation = async (queryAsAST, variables) => {
  const query = gqlToString(queryAsAST);
  
  try {
    return (await API.graphql(graphqlOperation(query, variables))).data;
  } catch(err) {
    logError({ error: err, query: query, variables: variables });
    return err;
  }
};

const flattenNestedObject = (oldObj, nestedObjKey, id) => {
  const newObj = clone(oldObj);
  delete newObj[nestedObjKey];
  newObj[id] = oldObj[nestedObjKey].id;
  return newObj;
};

// TODO better parameter names
export const prepareForSave = (oldObj, fixArr) => {
  let newObj =  clone(oldObj);

  delete newObj.createdBy;
  delete newObj.createdAt;

  if (newObj.__typename) {  
    delete newObj.__typename;
  }

  // TODO 0 check?
  // TODO support multiple fixArr params!
  if (fixArr && fixArr.length) {
    fixArr.map(({ from, to }) => {
      newObj = flattenNestedObject(newObj, from, to);
      return true;
    });
  }

  return stringsToNulls(newObj);
};


// BEGIN form specific

// TODO document
export const updateInPath = (oldObj, name, value) =>
  set(lensPath(name.split('.')), value, clone(oldObj));

// TODO use promise instead of callback?
export const saveHandler = (data, fixDataArr, gql, onSuccessFn) => {
  gqlOperation(gql, { input: prepareForSave(data, fixDataArr) })
    .then(() => { onSuccessFn(); })
    .catch(logError);
};

export const deleteHandler = (data, fixDataArr, gql, onSuccessFn) => {
  gqlOperation(gql, prepareForSave(data, fixDataArr))
    .then(() => { onSuccessFn(); })
    .catch(logError);
};

export const getCorrectPath = (path) => replace(/\/\//g, '/', path);



// BEGIN DYNAMO/AWSJSON related stuff



// TODO try/catch?
// TODOD it could accept nested keys!
export const parseAwsJson = (oldObj, keys) =>
  pipe(
    clone(),
    mapObjIndexed((val, key) => keys.includes(key) ?  JSON.parse(val) : val)
  )(oldObj);

export const parseAwsJsonInArr = (arr, keys) =>
  clone(arr).map(obj => parseAwsJson(obj, keys) );

const isNotNil = complement(isNil),
      isNotEmpty = complement(isEmpty);

// export const toAwsJson = (obj) => {

// };

// TODO deprecate
export const arrToAwsJson = (arr) =>
  pipe(
    clone(),
    filter(isNotNil),
    map(m => filter(isNotEmpty, m))
  )(arr);


// TODO not fully functional
const arrToEmptyObjByKey = (arr, key) =>
  pipe(
    map(obj => { return {[obj[key]]: ''}; }),
    mergeAll()
)(arr);

// TODO rename!!!
const prepareArrOfObj = (arr, key, num) => {
  const obj = arrToEmptyObjByKey(arr, key);

  return pipe(
    range(),
    map(() => clone(obj))
  )(0, num);
};


export const fillWithEmptyValues = (dataArr, sourceArr, key, l) =>
  concat(
    dataArr || [],
    prepareArrOfObj(
      sourceArr,
      key,
      l - (dataArr || []).length));

// this does not suit for objects!!!
// TODO: fix and test
export const toAwsJson = (arr) =>
  pipe(
    clone(),
    filter(isNotNil),
    map(m => filter(isNotEmpty, m)),
    filter(isNotEmpty),
    toString()
  )(arr);



// WEBPACK FOOTER //
// ./src/common/utils/utils.js